import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

export const withComponentDecisioner = (DefaultComponent) =>
  class ComponentWithComponentDecisioner extends React.PureComponent {
    static propTypes = {
      component: PropTypes.elementType,
    };

    static defaultProps = {
      component: DefaultComponent,
    };

    render() {
      const { component: Component, ...restProps } = this.props;
      return <Component {...restProps} />;
    }
  };

export const mapStateToProps = (decisionerConfigSelector) => (state) => {
  const decisionerConfig = decisionerConfigSelector(state);
  return {
    component: decisionerConfig?.find((decision) => decision.supports(state))?.component,
  };
};

export const ConnectedWithComponentDecisioner = (decisionerConfigSelector) => (DefaultComponent) =>
  connect(mapStateToProps(decisionerConfigSelector))(withComponentDecisioner(DefaultComponent));
